import { SelectedItemMap } from '@common/models';
import type { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface TearOutState {
    selectedTearOuts: SelectedItemMap;
}

const initialState: TearOutState = {
    selectedTearOuts: new Map(),
};

const tearOutSlice = createSlice({
    name: 'tearOut',
    initialState,
    reducers: {
        resetSelectedTearOuts: (state) => {
            state.selectedTearOuts = initialState.selectedTearOuts;
        },
        updateSelectedTearOuts: (state, action: PayloadAction<SelectedItemMap>) => {
            state.selectedTearOuts = action.payload;
        },
    },
});

export const { updateSelectedTearOuts, resetSelectedTearOuts } = tearOutSlice.actions;

export const selectSelectedTearOuts = ({ tearOut }: RootState): SelectedItemMap => tearOut.selectedTearOuts;

export default tearOutSlice.reducer;
